<template>
  <ValidationProvider :mode="validationModeComputed" v-slot="{ errors }" :rules="rulesComputed" :name="labelComputed">
    <v-textarea
      v-model="model"
      class="textarea-input pt-0 mt-0"
      ref="self"
      :label="fullLabel"
      :error-messages="errors"
      :hint="hint"
      :rows="rows"
      :autofocus="autofocus"
      dense
      outlined
      :clearable="clearable"
      clear-icon="mdi-close"
      no-resize
      auto-grow
      hide-details="auto"
      @blur="onBlur"
      :maxlength="maxLength"
    />
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
export default {
  name: 'TextareaInput',

  components: {
    ValidationProvider,
  },

  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      required: false,
      default: '',
    },
    hint: {
      type: String,
      required: false,
    },
    rows: {
      type: [String, Number],
      required: false,
      default: 4,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
    rules: {
      type: String,
      required: false,
      default: null,
    },
    validationMode: {
      type: String,
      required: false,
      default: 'aggressive',
    },
    maxLength: {
      //デフォルトの最大文字数を大きめに設定
      type: [String, Number],
      required: false,
      default: '1000',
    },
    autofocus: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {}
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
    fullLabel() {
      return this.required ? `${this.label} ${this.$t('ELE0024')}` : this.label
    },
    requiredComputed() {
      return this.required
    },
    rulesComputed() {
      if (this.rules && this.required) {
        return `required|${this.rules}`
      } else if (this.required) {
        return 'required'
      } else if (this.rules) {
        return this.rules
      } else {
        return ''
      }
    },
    validationModeComputed() {
      return this.validationMode
    },
    labelComputed() {
      return this.label
    },
  },

  methods: {
    onBlur() {
      this.$emit('blur')
    },
  },
}
</script>
<style>
/** 背景色指定 */
.textarea-input > .v-input__control > .v-input__slot {
  background: #edeffd;
  margin-bottom: 2px;
}
/** ボーダー色指定 */
.textarea-input > .v-input__control > .v-input__slot > fieldset {
  border-style: solid;
  border-width: 2px;
  border-color: var(--v-primary-base);
}
/* フォーカスが外れている場合のラベル色 */
.textarea-input > .v-input__control > .v-input__slot > .v-text-field__slot > .v-label {
  color: var(--v-primary-base);
}
/** エラーメッセージの上端が欠けるのを回避 */
.textarea-input > .v-input__control .v-messages {
  margin-top: 1px;
}

.textarea-input.v-input--is-disabled > .v-input__control > .v-input__slot > fieldset {
  background: #ffffff;
  border-color: rgba(0, 0, 0, 0.26);
  border-width: 1px;
  color: #000000;
}
/* 非活性のラベル色 */
.textarea-input.v-input--is-disabled > .v-input__control > .v-input__slot > .v-text-field__slot > .v-label {
  color: #000000 !important;
}

/* 非活性のラベル色 */
.theme--light.v-input--is-disabled input,
.theme--light.v-input--is-disabled textarea {
  color: #000000;
}
</style>
